'use client'

import { ControlledFormField } from 'lib/types/Form'
import { Controller, useForm } from 'react-hook-form'
import Button from '../Button/Button'
import { TextAreaInputStandalone } from '../Form/TextAreaInput/TextAreaInput'
import Modal from '../Modal/Modal'

interface ButtonsProps {
  text: string
  onCTAClick: (note: string) => void
}

export interface NoteModalProps extends Partial<ControlledFormField> {
  /**
   * ID of the modal
   */
  id: string
  /**
   * Title of the modal
   */
  title: string
  /**
   * Buttons of the modal
   */
  buttons?: ButtonsProps[]
}

export default function NoteModal({
  id,
  title,
  buttons,
  rules,
}: NoteModalProps) {
  const { control, handleSubmit, reset } = useForm()

  return (
    <Modal
      id={id}
      title={title}
      content={
        <form
          onSubmit={handleSubmit(() => {
            reset()
          })}
        >
          <Controller
            name={'note'}
            control={control}
            rules={rules}
            render={({ field, fieldState }) => {
              return (
                <>
                  <TextAreaInputStandalone
                    label="Note*"
                    error={fieldState.error?.message}
                    className="mb-6"
                    {...field}
                  />
                  {buttons && (
                    <div className="flex justify-center items-center gap-x-6 gap-y-2 flex-col md:flex-row">
                      {buttons.map(({ text, onCTAClick }, ctaKey) => (
                        <Button
                          onClick={() => onCTAClick?.(field.value)}
                          className="md:max-w-[15.625rem] !min-h-12 md:!min-h-[55px] w-full type-body-7 lg:type-body-5"
                          key={ctaKey}
                          type="submit"
                        >
                          {text}
                        </Button>
                      ))}
                    </div>
                  )}
                </>
              )
            }}
          />
        </form>
      }
    />
  )
}
